<div
  [ngClass]="['option-category', selected ? 'selected-category' : '']"
  (click)="onCategoryChange.emit(value)"
  (keydown.enter)="onCategoryChange.emit(value)">
  {{ display }} <fa-icon [icon]="['fas', 'chevron-right']"></fa-icon>
</div>
